import React from 'react'
import Birthday from './../cake.svg';
const BirthdayIcon = () => {
    return (
        <img src={Birthday} style={{ height: '32px', width: '32px' }} />
    )
}

export default BirthdayIcon